import type { NormalizedTranscriptEntry, SessionDataAdapter } from "./sessionAdapter";

/**
 * Factory for the session data adapter of a provider whose transcript is
 * captured locally (see `localTranscriptStore`). There is nothing to poll:
 * the buffer is already complete when the session ends, and the session meta
 * is derived from it. Kaltura and D-ID both use this; only the buffer they
 * read and the `raw.source` label differ.
 */
export function createLocalSessionAdapter(opts: {
  readTranscript: (sessionId: string) => NormalizedTranscriptEntry[];
  source: string;
}): SessionDataAdapter {
  return {
    async fetchSessionMeta(sessionId) {
      const rows = opts.readTranscript(sessionId);
      const last = rows[rows.length - 1];
      return {
        session_id: sessionId,
        // Derived locally — these providers report no session duration.
        duration: last ? last.relative_timestamp : 0,
        turns: rows.length,
        source: "local",
      };
    },
    async fetchTranscript(sessionId) {
      const rows = opts.readTranscript(sessionId);
      if (!rows.length) return null;
      return {
        session_active: false,
        transcript_data: rows,
        raw: { source: opts.source, turns: rows.length },
      };
    },
  };
}
